<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/classroomList' }">
					<i class="el-icon-film"></i> 教室管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新教室信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
				  <el-col :span="12">
					<el-form-item :label="'教室ID'" prop="sbaMSID">
						<el-input v-model="ruleForm.sbaMSID" :disabled="true">></el-input>
					</el-form-item>
				  </el-col>
				 </el-row>
				 <el-row>
				 <el-col :span="24">
				 	<el-form-item :label="'所属幼儿园'" prop="sbaSAAI">
				 	<el-select v-model="ruleForm.sbaSAAI" clearable 
				 	:placeholder="'请选择幼儿园'" class="handle-select mr10":disabled="true" >
				 	   <el-option
				 		 v-for="item in ruleForm.optionsSAAI"
				 		 :key="item.SAAMSID"
				 		 :label="item.SAANAME"
				 		 :value="item.SAAMSID">
				 	   </el-option>
				 	</el-select>
				 	</el-form-item>
				 </el-col>
				 </el-row>
				<el-row>
				  <el-col :span="12">
					<el-form-item :label="'教室名称'" prop="sbaNAME">
						<el-input v-model="ruleForm.sbaNAME" :placeholder="'请输入教室名称'" maxlength="20"></el-input>
					</el-form-item>
				  </el-col>
				 </el-row>
				<el-row>
				<el-col :span="24">
					<el-form-item :label="'删除状态'" prop="sbaDELF">
					<el-select v-model="ruleForm.sbaDELF" clearable 
					:placeholder="'请选择删除状态'" class="handle-select mr10">
					   <el-option
						 v-for="item in ruleForm.optionsDELF"
						 :key="item.INIKEY2"
						 :label="item.INIDISP"
						 :value="item.INIKEY2">
					   </el-option>
					</el-select>
					</el-form-item>
				</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>	
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editClassroom',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule,value,callback)=>{	
				if (value.toString().length == 0) {
					callback(new Error('请输入教室名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkSBANAME(value);
					if (this.isRepeat == true) {
						callback(new Error('教室名称重复'));
					} else {
						callback();
					}
				}
			 }
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				sbaChangeData: {},
				
				isRepeat: false,
				ruleForm: {
					sbaMSID: '',
					sbaSAAI: '',
					optionsSAAI: [],
					sbaNAME: '',
					sbaDELF:''
				},
				rules: {
					sbaNAME: [{
						required: true,
						//message: '请输入教室名称', 
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					
					sbaDELF:[
						{ 
						 required: true, 
						 message: '请选择删除状态', 
						 trigger:['blur','change']
						}
					]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editClassroom") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.sbaMSID = this.$route.query.SBAMSID;
			this.getSAAI(); 	//幼儿园
			this.getDELF(); //获取删除状态
			this.getData(this.sbaMSID);
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			dummyCreated () {
				this.sbaMSID = this.$route.query.SBAMSID;
				this.getSAAI(); 	//幼儿园
				this.getDELF(); //获取删除状态
				this.getData(this.sbaMSID);
			},
			//获取删除信息
			getDELF(){
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10005 //删除 10005
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsDELF= response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					message: '获取删除状态请求失败',  //请求失败
					type: 'error'
					});
					
				});
			},
			//验证此幼儿园下，教室名称是否重复
			checkSBANAME(value) {
				const self_shop = this;
				
				var postUrl = 'WCF/WEB/svcSBA.svc/CHECK_SBA_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.sbaSAAI,
						sSBAID: self_shop.ruleForm.sbaMSID,
						sSBANM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取幼儿园信息
			getSAAI(){
				const self_shop = this;
				var postUrl='WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon //web侧 登录邮箱
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsSAAI= response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					message: '获取幼儿园请求失败',  //请求失败
					type: 'error'
					});
					
				});
			},
			//获取宝宝信息
			getData(sbaMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcSBA.svc/GET_SBA_BYID';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self.web_sphon, 
						sMSID: sbaMSID //会社ID
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resStatus = response.status;
					if (resStatus == "200") { //网络请求成功
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							//返回列信息赋值到页面上 
						self.ruleForm.sbaMSID = response.data.KKDT[0].SBAMSID;
						self.ruleForm.sbaSAAI = response.data.KKDT[0].SBASAAI;
						self.ruleForm.sbaNAME = response.data.KKDT[0].SBANAME;  
						self.ruleForm.sbaDELF = response.data.KKDT[0].SBADELF;
							
						this.sbaChangeData = response.data.KKDT[0];
						
						} 
						else {
							this.$message({
								message: '获取数据失败', //无数据
								type: 'error'
							});
						}
					} 
					else {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求获取数据失败', //请求失败
						type: 'error'
					});
				});
			},
			//保存会社信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
	
						const self = this;
						var valDELF;
						if(self.ruleForm.sbaDELF == "undefined")
						{
							valDELF = '';
						}
						else
						{
							valDELF = self.ruleForm.sbaDELF;
						}
						
						let sbaFlag=false;
						if(this.sbaChangeData.SBANAME != this.ruleForm.sbaNAME)
						{
							sbaFlag = true;
						}
						
						
						if(this.sbaChangeData.SBADELF != valDELF)
						{
							sbaFlag = true;
						}
		
						var postUrl = 'WCF/WEB/svcSBA.svc/UPD_SBA_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sMSID: self.sbaMSID, //宝宝ID
									sSBANAME: self.ruleForm.sbaNAME,  
									sSBADELF: self.ruleForm.sbaDELF
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '教室信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('教室信息更新成功'); // 编辑成功
										this.$router.push('/classroomList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editClassroom") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新教室信息失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新教室信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editClassroom") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.el-dialog__footer {
		text-align: center;
	}
	
	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	
	
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}
</style>
